<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">

            <el-form-item label="姓名" prop="name">
                <el-input clearable v-model="dataForm.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="zzdyqc">
                <el-input clearable v-model="dataForm.zzdyqc" disabled></el-input>
            </el-form-item>
            <el-form-item label="工号" prop="workNumber">
                <el-input clearable v-model="dataForm.workNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="gw">
                <el-input clearable v-model="dataForm.gw" disabled></el-input>
            </el-form-item>
            <el-form-item label="出勤" prop="workDays">
                <el-input clearable v-model="dataForm.workDays" ></el-input>
            </el-form-item>
            <el-form-item label="夜班次数" prop="nightDays">
                <el-input clearable v-model="dataForm.nightDays" ></el-input>
            </el-form-item>
            <el-form-item label="病假天数" prop="sickDays">
                <el-input clearable v-model="dataForm.sickDays" ></el-input>
            </el-form-item>
            <el-form-item label="事假天数" prop="shiDays">
                <el-input clearable v-model="dataForm.shiDays" ></el-input>
            </el-form-item>
            <el-form-item label="加班天数" prop="addWokr">
                <el-input clearable v-model="dataForm.addWokr" ></el-input>
            </el-form-item>
            <el-form-item label="旷工" prop="noWorkDays">
                <el-input clearable v-model="dataForm.noWorkDays" ></el-input>
            </el-form-item>
            <el-form-item label="其他" prop="other">
                <el-input clearable v-model="dataForm.other" ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input clearable v-model="dataForm.remark" ></el-input>
            </el-form-item>


            <!-- <el-form-item label="工资模板名称" prop="salaryTemplateId">
                <el-select :disabled="dataForm.type !== 2"  clearable v-model="dataForm.salaryTemplateId" placeholder="请选择">
                    <el-option v-for="item in templates" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            const validateNumber = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        callback()
                    }
                } else callback()
            }
            return {
                //表单验证规则
                rules: {
                    id: [],
                    collectId: [],
                    name: [],
                    zzdyqc: [],
                    workNumber: [],
                    workDays: [],
                    nightDays: [{validator:validateNumber,trigger: 'blur'}],
                    sickDays: [{validator:validateNumber,trigger: 'blur'}],
                    shiDays: [{validator:validateNumber,trigger: 'blur'}],
                    addWokr: [{validator:validateNumber,trigger: 'blur'}],
                    noWorkDays: [{validator:validateNumber,trigger: 'blur'}],
                    other: [],
                    remark: [],
                    gw: [],
                    zaddWokr: [],
                    holiday24: [],
                    holiday12: [],
                    type: [],
                    bmid: [],
                    userId: [],
                    month: [],
                    salaryTemplateId: [],
                    salaryTemplateName: [],
                },
                visible: false,
                dataForm: {
                id: '',
                collectId: '',
                name: '',
                zzdyqc: '',
                workNumber: '',
                workDays: '',
                nightDays: '',
                sickDays: '',
                shiDays: '',
                addWokr: '',
                noWorkDays: '',
                other: '',
                remark: '',
                gw: '',
                zaddWokr: '',
                holiday24: '',
                holiday12: '',
                type: '',
                bmid: '',
                userId: '',
                month: '',
                salaryTemplateId: '',
                salaryTemplateName: '',
                },
                templates:[]
            }
        },
        methods: {
            init (id) {
                this.dataForm.id = id
                this.visible = true
                this.getTypes()
                this.$nextTick
                (() => {
                    this.$refs['dataForm'].resetFields()
                    if(this.dataForm.id) {
                        this.$http({
                            url: '/bjba/kqcollectData/info/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm.id    = data.data.id
                            this.dataForm.collectId    = data.data.collectId
                            this.dataForm.name    = data.data.name
                            this.dataForm.zzdyqc    = data.data.zzdyqc
                            this.dataForm.workNumber    = data.data.workNumber
                            this.dataForm.workDays    = data.data.workDays
                            this.dataForm.nightDays    = data.data.nightDays
                            this.dataForm.sickDays    = data.data.sickDays
                            this.dataForm.shiDays    = data.data.shiDays
                            this.dataForm.addWokr    = data.data.addWokr
                            this.dataForm.noWorkDays    = data.data.noWorkDays
                            this.dataForm.other    = data.data.other
                            this.dataForm.remark    = data.data.remark
                            this.dataForm.gw    = data.data.gw
                            this.dataForm.zaddWokr    = data.data.zaddWokr
                            this.dataForm.holiday24    = data.data.holiday24
                            this.dataForm.holiday12    = data.data.holiday12
                            this.dataForm.type    = data.data.type
                            this.dataForm.bmid    = data.data.bmid
                            this.dataForm.userId    = data.data.userId
                            this.dataForm.month    = data.data.month
                            this.dataForm.salaryTemplateId    = data.data.salaryTemplateId
                            this.dataForm.salaryTemplateName    = data.data.salaryTemplateName
                        })
                    }
                })

            },
            getTypes() {
                this.$request.get('/bjba/salary/template/queryAll').then(res => {

                    this.templates = res.data.data;
                })
            },
            changeTemplate(template) {
                if (template) {

                }
            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
              this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.$http({
                        url: `/bjba/kqcollectData/save`,
                        method: 'post',
                        data: this.dataForm
                    }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                         })
                        this.visible = false
                        this.$emit
                        ('refreshDataList')
                    } else if(data && data.code === 500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                    })
                    }
                })
            }
        }
    }
</script>
